import React from 'react';

import gdpr_flow from './items/gdpr_flow.js';
import { defaultRegistry } from './flows';
import { StoresProvider } from './store/react';
import { useStoresSingleton } from './hooks/useStoresSingleton';
import { useSessionTransport } from './hooks/useSessionTransport';
import ShellBody from './components/shell_body.jsx';
import './layout.css';

export default function Shell() {
    const singleton = useStoresSingleton(defaultRegistry, gdpr_flow.id);
    useSessionTransport(singleton);
    return (
        <StoresProvider value={singleton}>
            <ShellBody />
        </StoresProvider>
    );
}
